import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { SUBSCRIPTION_DETAIL_QUERY_KEY } from "./constants";
import type { AdminSubscriptionDetail } from "./types";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. `GET /api/admin/subscriptions/:id`
 * returns the full subscription record reconciled with Stripe.
 */
async function fetchSubscriptionDetail(id: string): Promise<AdminSubscriptionDetail> {
  return httpClient<AdminSubscriptionDetail>(`/api/admin/subscriptions/${encodeURIComponent(id)}`);
}

export function useSubscriptionDetail(id: string) {
  return useQuery({
    queryKey: [...SUBSCRIPTION_DETAIL_QUERY_KEY, id] as const,
    queryFn: () => fetchSubscriptionDetail(id),
    staleTime: 30_000,
  });
}
